/* global localStorage, window */
import { environment } from "environment";

export const AUTH_STATUS_KEY = "xob_auth_status";
export const AUTH_STATUS_LOGGED_IN = "loggedIn";
export const ACCESS_TOKEN_KEY = "xob_access_token";
export const AUTH_USER_KEY = "xob_auth_user";
export type AppRoute = "home" | "auth" | "reviewer";
export const HOME_HASH = "#/";
export const AUTH_HASH = "#/auth";
export const REVIEWER_HASH = "#/reviewer";

const API_BASE = environment.apiBaseUrl;

export const getApiBase = () => API_BASE;
export const buildApiUrl = (path: string) =>
  `${API_BASE.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;

export const saveAuthSession = (accessToken: string, user?: unknown) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }
  if (user) {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  }
};

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getAuthUser = (): unknown | null => {
  const raw = localStorage.getItem(AUTH_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};

// Clean up legacy flag if it lingers without a token.

export const isLoggedIn = (): boolean => Boolean(getAccessToken());

const setHash = (hash: string) => {
  if (window.location.hash !== hash) {
    window.location.hash = hash;
  }
};

export const redirectToMainPage = () => setHash(HOME_HASH);

export const redirectToAuth = () => setHash(AUTH_HASH);

export const redirectToReviewer = () => setHash(REVIEWER_HASH);

export const currentRoute = (): AppRoute => {
  const hash = (window.location.hash || "").toLowerCase();
  if (hash.startsWith(AUTH_HASH)) {
    return "auth";
  }
  if (hash.startsWith(REVIEWER_HASH)) {
    return "reviewer";
  }
  return "home";
};
